import UserEditInfoView from 'app/views/user_edit_info_view';
import UserEditPasswordView from 'app/views/user_edit_password_view';
import Base from 'app/views/base';

import tmpl from 'templates/user_edit_page';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'user-info',

  events: {},

  initialize() {
    this.addSubview('userInfo', '#user_info', new UserEditInfoView({ model: this.model }));
    this.addSubview('userPassword', '#user_password', new UserEditPasswordView({ model: this.model }));
  },
});



// WEBPACK FOOTER //
// ./app/views/user_edit_page.js